"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EmailInfo = /** @class */ (function () {
    function EmailInfo(source) {
        this.emailId = source ? source.emailId : -1;
        this.email = source ? source.email : '';
    }
    return EmailInfo;
}());
exports.EmailInfo = EmailInfo;
//# sourceMappingURL=EmailInfo.js.map